import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { TabBarItem } from '../tab-bar/tab-bar.models';

@Component({
    selector: 'ms-live-grid-footer',
    templateUrl: 'live-grid-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LiveGridFooterComponent {
    @HostBinding('class') className = 'grid-footer grid-live-footer ms-active-highlight';
    @Input() model: TabBarItem;
    constructor(private sitecore: Sitecore) {}

    get title(): string {
        return this.sitecore.globalMessages.AllLiveEventsForSport.replace('{0}', this.model.title!);
    }
}
